import { render } from "./CreatePrefence.vue?vue&type=template&id=146b88fc"
import script from "./CreatePrefence.vue?vue&type=script&lang=js"
export * from "./CreatePrefence.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__